import {Deserializable} from "./deserializable.model";

export class SubjectCostItem {

  subject_cost_item_id?: number;
  cost_task_name?: string;
  myob_tax_code_id?: number;
  myob_account_code_id?: number;
  cost_task_description?: string;
  cost_task_fee?: number;
  cost_task_id?: number;
  subject_id: number;
  subject_number?: number;
  job_id: number;
  job_number?: number;
  work_order_status?: string;
  work_order_id?: number;
  work_order_number?: number;

  agent_id?: number;
  agent_full_name?: string;

  // new
  qty?: number; // do this later down the track...

  // Need to create the missing invoice items details so that I can push back to the invoice once removed/deleted or updated
  // Feb 2023
  unit_price?: number;
  tax?: number;
  total?: number
  is_bulk?;



  // ? what does this really do? (no encoding or deserialisation required...)
  // deserialize(input: any): SubjectBillingItem {
  //   Object.assign(this, input);

  //   return this;
  // }

  /*
subject_billing_item_id
billing_task_name
myob_tax_code_id
myob_account_code_id
billing_task_description
billing_task_fee
billing_task_id
subject_id
subject_number
job_id
job_number
  */


}
